import React, { useEffect, useState, useMemo,useRef } from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import PONegotiationTable from "./PONegotiationTable";
import LotAllocationTable from "./LotAllocationTable";
import DeliveryDetailsTable from "./DeliveryDetailsTable";
import PODetailsTable from "./PODetailsTable";
import ProductDetailsTable from "./ProductDetailsTable";
import CommentsBox from "./CommentsBox";
import PricingTable from "./PricingTable";
import EditResponsibleRespond from "../POColumns/EditResponsibleRespond";
//import { fetchUserAssociation } from "../../../containers/actions/common/purchaseOrderAction";

import axios from "axios";
import { appUrl } from "../../../../../../utils/config";
import moment from "moment";
import { getFeaturesAccess } from "../../../../containers/actions/common/accessControl";
import { fetchSLFromPODashboard } from "../../../../containers/actions/common/purchaseOrderAction";
import { useDispatch, useSelector } from "react-redux";
// import axios from "axios";
// import { CircularProgress } from "@material-ui/core";

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ padding: "0px 10px", marginTop: "-5px" }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

// const useStyles = makeStyles((theme) => ({
//   root: {
//     flexGrow: 1,
//     marginTop: "-15px",
//   },
//   tabs: {
//     backgroundColor: "#fff",
//     color: "#000",
//   },
//   tab: {
//     minWidth: 120,
//     textTransform: "none",
//     fontWeight: theme.typography.fontWeightRegular,
//     marginTop: "8px",
//     position: "relative",
//     "&::before": {
//       content: '""',
//       position: "absolute",
//       top: 0,
//       left: "50%",
//       width: "90%",
//       height: "4px",
//       backgroundColor: "#ccc",
//       transform: "translateX(-50%)",
//     },
//     "&.Mui-selected": {
//       color: "#34a0f7",
//       borderBottom: "3px solid #34a0f7 !important",
//     },
//   },

//   poDetails: {
//     "&::before": { backgroundColor: "#ed82ca !important" },
//   },
//   productDetails: {
//     "&::before": { backgroundColor: "#4CAF50 !important" },
//   },
//   lotAllocation: {
//     "&::before": { backgroundColor: "#4CAF50 !important" },
//   },
//   deliveryDetails: {
//     "&::before": { backgroundColor: "#4CAF50 !important" },
//   },
//   timeQtyDetails: {
//     "&::before": { backgroundColor: "#ed82ca !important" },
//   },
//   comments: {
//     "&::before": { backgroundColor: "#34a0f7 !important" },
//   },
//   indicator: {
//     display: "none",
//   },
// }));

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    marginTop: "-15px",
  },
  tabs: {
    backgroundColor: "#fff",
    color: "#000",
  },
  tab: {
    minWidth: 120,
    textTransform: "none",
    fontWeight: theme.typography.fontWeightRegular,
    marginTop: "8px",
    position: "relative",
    "&::before, &::after": {
      content: '""',
      position: "absolute",
      left: "50%",
      width: "88%",
      height: "4px",
      transform: "translateX(-50%)",
    },
    "&::before": {
      top: 0,
      backgroundColor: "#ccc",
    },
    "&::after": {
      bottom: 0,
      backgroundColor: "transparent",
    },

    "&.Mui-selected": {
      color: "#34a0f7",
      "&::after": {
        backgroundColor: "#34a0f7",
      },
    },
  },

  poDetails: {
    "&::before": { backgroundColor: "#712B5D !important" },
  },
  productDetails: {
    "&::before": { backgroundColor: "#653672 !important" },
  },
  lotAllocation: {
    "&::before": { backgroundColor: "#56448C !important" },
  },
  deliveryDetails: {
    "&::before": { backgroundColor: "#4D4D9D !important" },
  },
  timeQtyDetails: {
    "&::before": { backgroundColor: "#3F59B4 !important" },
  },
  pricing: {
    "&::before": { backgroundColor: "#3065C0 !important" },
  },
  comments: {
    "&::before": { backgroundColor: "#3662C4 !important" },
  },
  indicator: {
    display: "none",
  },
}));


export default function POTabs({
  data,
  messages,
  handleRefresh,
  handleQuickSummaryRefresh,
  openedPOTab,
  handleOpenPOTab,
  showPencilIcon,
  slDetails,
}) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [value, setValue] = useState(openedPOTab ? openedPOTab : 0);
  const previousTabRef = useRef(openedPOTab ? openedPOTab : 0);
  const [chatData, setChatData] = useState(null);
  const [loading, setLoading] = useState(true);

  // BCM-972 ("Highlighting of the Planned MFG Start Date"): earliest expiry
  // date across this PO's allocated batches, needed to redden Planned MFG
  // Start Date once it falls after that expiry. null = not fetched yet /
  // nothing allocated, both of which mean "no highlight".
  const [allocatedBatchExpiryDate, setAllocatedBatchExpiryDate] = useState(null);

  // BCM-972 ("Post-consumption view" tooltip): customFileType names (e.g.
  // "Certificate of Manufacture", "Certificate of Analysis") of the files
  // whose documentCategoryType is "Post-Manufacturing" — shown as the
  // checklist in the Planned MFG Start Date lock tooltip.
  const [postManufacturingDocumentTypes, setPostManufacturingDocumentTypes] = useState([]);

  // BCM-972: the full fetchDeliveryScheduleBatchDetails response — carries
  // scheduleAgreementNumber/vendorBatchNumber (PO/Batch number for the tooltip's
  // meta line) and is also exactly the `batchDetails` shape ViewStructuredInformation
  // ("View Digitalized Information") expects, so "View batch documents" can open
  // that same dialog without a second fetch.
  const [deliveryScheduleBatchDetails, setDeliveryScheduleBatchDetails] = useState(null);

  //console.log("showPencilIcon value in potabs",showPencilIcon)
  //console.log("slDetails in POTabs", slDetails)

  // BCM-972: fetchDeliveryScheduleBatchDetails, called on the same trigger as
  // everything else here — POTabs mounting when the row's chevron opens.
  useEffect(() => {
    let isMounted = true;
    const dsbID = data?.batchDetails?.schrockenDeliveryScheduleBatchID;
    if (!dsbID) {
      setPostManufacturingDocumentTypes([]);
      setDeliveryScheduleBatchDetails(null);
      return;
    }
    axios
      .post(
        `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchDeliveryScheduleBatchDetails`,
        { schrockenDeliveryScheduleBatchID: dsbID }
      )
      .then((res) => {
        if (!isMounted) return;
        const customFilesList = res.data?.data?.customFilesList || [];
        const documentTypes = [
          ...new Set(
            customFilesList
              .filter((file) => file?.documentCategoryType === "Post-Manufacturing")
              .map((file) => file?.customFileType)
              .filter(Boolean)
          ),
        ];
        setPostManufacturingDocumentTypes(documentTypes);
        setDeliveryScheduleBatchDetails(res.data?.data || null);
      })
      .catch((err) => {
        console.error("Failed to fetch delivery schedule batch details for document categories:", err);
        if (isMounted) {
          setPostManufacturingDocumentTypes([]);
          setDeliveryScheduleBatchDetails(null);
        }
      });
    return () => {
      isMounted = false;
    };
  }, [data?.batchDetails?.schrockenDeliveryScheduleBatchID]);

  // BCM-972: same two endpoints Batch Allocation already calls (LotAllocationTable.jsx
  // fetchLotAllocationData), picked the same way, by data?.batchDetails?.bomConsumptionAddedIndicator,
  // and fired on the same trigger — POTabs mounting when the row's chevron opens.
  // Both branches feed the red-highlight comparison: even though ViewRmPmLotTable.jsx
  // (bomConsumptionAddedIndicator===true) never prints the expiry date as visible
  // text — only a red/yellow FlagIcon, compared against *today* — the underlying
  // plannedLotNumberAllocationDetails[].expiryDate is the same real allocated-batch
  // expiry data, so it's still the right source for the Planned MFG Start Date
  // comparison even where this particular table doesn't surface the raw date itself.
  useEffect(() => {
    let isMounted = true;
    const batchDetails = data?.batchDetails;
    const schrockenSLID = data?.scheduleLineDetails?.schrockenSLID;
    const bomConsumptionAddedIndicator = batchDetails?.bomConsumptionAddedIndicator;

    // BCM-972 (false/undefined branch): must stay in sync with the "Expiry Date"
    // column LotAllocationTable.jsx itself renders (see its own "Table rendering
    // logic" comment, ~line 1826), which is a 3-case fallback PER COMPONENT, not
    // always the same field:
    //   Case 1 — lotNumberAllocationDetails has rows: show each lot's own expiryDate
    //            (the batch actually ALLOCATED to this PO).
    //   Case 2 — no lots, but inventoryDetails has 1-3 rows: show each inventoryDetails
    //            entry's inventoryExpiryDate instead (few enough candidates that the
    //            table lists them as if allocated).
    //   Case 3 — neither (or inventoryDetails has 4+ rows with no lots): the column is
    //            blank — nothing to collect.
    // (true branch): plannedLotNumberAllocationDetails[].expiryDate always — no such
    // fallback exists in ViewRmPmLotTable.jsx.
    const collectExpiryDates = (rawList) => {
      const dates = [];
      (rawList || []).forEach((component) => {
        if (bomConsumptionAddedIndicator) {
          (component?.plannedLotNumberAllocationDetails || []).forEach((lot) => {
            if (lot?.expiryDate) dates.push(lot.expiryDate);
          });
          return;
        }
        const lots = component?.lotNumberAllocationDetails || [];
        const inventory = component?.inventoryDetails || [];
        if (lots.length > 0) {
          lots.forEach((lot) => {
            if (lot?.expiryDate) dates.push(lot.expiryDate);
          });
        } else if (inventory.length > 0 && inventory.length < 4) {
          inventory.forEach((inv) => {
            if (inv?.inventoryExpiryDate) dates.push(inv.inventoryExpiryDate);
          });
        }
      });
      return dates;
    };

    const fetchEarliestAllocatedBatchExpiry = async () => {
      if (!batchDetails && !schrockenSLID) return;
      try {
        let rawList = [];
        if (bomConsumptionAddedIndicator) {
          const dsbID = batchDetails?.schrockenDeliveryScheduleBatchID;
          const batchSize = batchDetails?.batchSize;
          if (!dsbID) return;
          const url = `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchComponentAllocationPlannedAndActualNewDirect/${dsbID}/${batchSize}`;
          const res = await axios.get(url);
          if (res.data?.status && Array.isArray(res.data.data)) rawList = res.data.data;
        } else {
          if (!schrockenSLID) return;
          const url = `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchComponentAllocationForPOLineNewDirect/${schrockenSLID}`;
          const res = await axios.get(url);
          if (res.data?.status && Array.isArray(res.data.data?.componentAllocationDataList)) {
            rawList = res.data.data.componentAllocationDataList;
          }
        }

        const parsedDates = collectExpiryDates(rawList)
          .map((d) => new Date(d))
          .filter((d) => !isNaN(d));

        if (isMounted) {
          setAllocatedBatchExpiryDate(
            parsedDates.length > 0 ? new Date(Math.min(...parsedDates)).toISOString() : null
          );
        }
      } catch (err) {
        console.error("Failed to fetch allocated batch expiry for Planned MFG Start Date highlight:", err);
        if (isMounted) setAllocatedBatchExpiryDate(null);
      }
    };

    fetchEarliestAllocatedBatchExpiry();
    return () => {
      isMounted = false;
    };
  }, [
    data?.batchDetails?.bomConsumptionAddedIndicator,
    data?.batchDetails?.schrockenDeliveryScheduleBatchID,
    data?.batchDetails?.batchSize,
    data?.scheduleLineDetails?.schrockenSLID,
  ]);

  const tabsData = useMemo(() => {
    // If we have slDetails from API, use it to create specific data for each tab
    if (slDetails && slDetails.data) {
      const apiData = slDetails.data;
      
      return {
        // PO Details Tab - Basic schedule line information
        poDetailsData: {
          ...data,
          batchDetails: {
            ...apiData?.batchDetails,
          },
          scheduleLineDetails: {
            ...data?.scheduleLineDetails,
            ...(apiData?.scheduleLineDetails || {}),
          },
        },
        
        // Product Details Tab - Product-specific information
        productDetailsData: {
          ...data,
          scheduleLineDetails: {
            ...data?.scheduleLineDetails,
            ...(apiData?.scheduleLineDetails || {}),
          },
          productDetails: apiData?.productDetails || data?.productDetails || {},
        },
        
        // Delivery Details Tab - Delivery and logistics information
        deliveryDetailsData: {
          ...data,
          scheduleLineDetails: {
            ...data?.scheduleLineDetails,
            ...(apiData?.scheduleLineDetails || {}),
          },
          deliveryDetails: apiData?.deliveryDetails || data?.deliveryDetails || {},
          batchDetails: apiData?.batchDetails || data?.batchDetails || {},
        },
        
        // Time and Qty Details Tab - Negotiation and quantity information
        timeQtyDetailsData: {
          ...data,
          scheduleLineDetails: {
            ...data?.scheduleLineDetails,
            ...(apiData?.scheduleLineDetails || {}),
            // BCM-972: fgMaterialCode/fgMaterialName (EditPlannedMfgStartDate's
            // access-request payload) come from fetchPurchaseOrdersNewDirect
            // (data) strictly — always read from there, regardless of whatever
            // fetchSLFromPODashboard (apiData) sends for these fields.
            fgMaterialCode: data?.scheduleLineDetails?.fgMaterialCode,
            fgMaterialName: data?.scheduleLineDetails?.fgMaterialName,
            // BCM-972: earliest expiry among this PO's allocated batches, fetched above
            allocatedBatchExpiryDate,
            // BCM-972: Post-Manufacturing document types already received, fetched above
            postManufacturingDocumentTypes,
            // BCM-972: full fetchDeliveryScheduleBatchDetails response, fetched above
            deliveryScheduleBatchDetails,
          },
          // BCM-972: EditPlannedMfgStartDate's lock condition reads
          // batchDetails.bomConsumptionAddedIndicator — needs the fresh value
          // from fetchSLFromPODashboard, same as every other tab that uses
          // batchDetails, not the original (possibly stale) list-fetch data.
          batchDetails: apiData?.batchDetails || data?.batchDetails || {},
          negotiationDetails: apiData?.negotiationDetails || data?.negotiationDetails || {},
        },
        
        // Batch Allocation Tab - Needs API data for Edit Planned Allocated Quantity fields
        batchAllocationData: {
          ...data,
          scheduleLineDetails: {
            ...data?.scheduleLineDetails,
            ...(apiData?.scheduleLineDetails || {}),
          },
          batchDetails: apiData?.batchDetails || data?.batchDetails || {},
        },
        
        // Pricing Tab - Pricing fields from scheduleLineDetails / pricingDetails
        pricingData: {
          ...data,
          scheduleLineDetails: {
            ...data?.scheduleLineDetails,
            ...(apiData?.scheduleLineDetails || {}),
          },
          pricingDetails: apiData?.pricingDetails || data?.pricingDetails || {},
        },

        // Comments Tab - Uses original data only (not from fetchSLFromPODashboard)
        commentsData: {
          ...data,
          scheduleLineDetails: {
            ...data?.scheduleLineDetails,
            ...(apiData?.scheduleLineDetails || {}),
          },
        },
      };
    }
    
    // If no slDetails, use original data for all tabs
    return {
      poDetailsData: data,
      productDetailsData: data,
      deliveryDetailsData: data,
      timeQtyDetailsData: {
        ...data,
        scheduleLineDetails: {
          ...data?.scheduleLineDetails,
          // BCM-972: earliest expiry among this PO's allocated batches, fetched above
          allocatedBatchExpiryDate,
          // BCM-972: Post-Manufacturing document types already received, fetched above
          postManufacturingDocumentTypes,
          // BCM-972: full fetchDeliveryScheduleBatchDetails response, fetched above
          deliveryScheduleBatchDetails,
        },
      },
      batchAllocationData: data,
      pricingData: data,
      commentsData: data,
    };
  }, [data, slDetails, allocatedBatchExpiryDate, postManufacturingDocumentTypes, deliveryScheduleBatchDetails]);
  
  const screenAccess = useSelector(
    (state) =>
      state.pcmp.common.accessControl.screensAccess.data
        .poCollaborationDashboard
  );

  const featuresAccess = useSelector(
    (state) =>
      state.pcmp.common.accessControl.featuresAccess.poCollaborationDashboard
  );

  useEffect(() => {
    if (screenAccess?.screenAccess && !featuresAccess)
      dispatch(
        getFeaturesAccess(screenAccess?.screenId, "poCollaborationDashboard")
      );
  }, [dispatch, screenAccess, featuresAccess]);

  const scheduleLineStatusID = tabsData.poDetailsData?.scheduleLineDetails?.scheduleLineStatusID;
  const newProposalFlag = tabsData.poDetailsData?.scheduleLineDetails?.newProposalFlag;

  //const unreadCommentsPresent = data?.chatData?.unreadCommentsPresent;
  //console.log("chatData", chatData);

  // Enhanced handleRefresh that refreshes both parent data and SL details from API
  const handleRefreshWithSLData = (type) => {
    const schrockenSLID = data?.scheduleLineDetails?.schrockenSLID;
    
    // Call the original handleRefresh from parent (PurchaseOrderTabTable)
    if (handleRefresh) {
      handleRefresh(type);
    }
    
    // Fetch updated SL details from API to refresh all tabs with latest data
    if (schrockenSLID) {
      dispatch(fetchSLFromPODashboard(schrockenSLID))
        .then((updatedData) => {
          // console.log("SL Details refreshed after edit:", updatedData);
        })
        .catch((error) => {
          console.error("Failed to refresh SL details:", error);
        });
    }
  };

  
  const handleRefreshOnlySLData = () => {
    const schrockenSLID = data?.scheduleLineDetails?.schrockenSLID;

    if (handleRefresh) {
      handleRefresh('withoutQuickSummary');
    }

    if (schrockenSLID) {
      dispatch(fetchSLFromPODashboard(schrockenSLID)).catch((error) => {
        console.error("Failed to refresh SL details:", error);
      });
    }
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
    handleOpenPOTab(newValue);
  };

  // Batch Allocation is not applicable when fetchSLFromPODashboard returns
  // subContractingPOs: false; when the value is absent the tab behaves as before.
  const batchAllocationNotApplicable =
    (slDetails?.data?.scheduleLineDetails?.subContractingPOs ??
      data?.scheduleLineDetails?.subContractingPOs) === false;

  // Move off the Batch Allocation tab if it becomes disabled while selected
  useEffect(() => {
    if (batchAllocationNotApplicable && value === 2) {
      setValue(0);
      handleOpenPOTab(0);
    }
  }, [batchAllocationNotApplicable, value]);

  const tabMapping = [
    "PO Details", // Tab 0
    "Product Details", // Tab 1
    "Batch Allocation", // Tab 2
    "Delivery Details", // Tab 3
    "Time and Qty. Details", // Tab 4
     "Pricing", // Tab 5
    // "Comments", // Tab 6
    "Comments", // Tab 5
  ];

  useEffect(() => {
    if (data && previousTabRef.current !== value) {
      const validTabs = [
        "PO Details",
        "Product Details",
        "Time and Qty. Details",
        "Batch Allocation",
        // "Comments" is excluded - CommentsBox component handles updateUserActivity internally
      ];

      const tabLabel = tabMapping[value];

      if (validTabs.includes(tabLabel)) {
        // Check if notification flag is true for this tab
        let hasNotification = false;
        if (tabLabel === "Product Details") {
          hasNotification = tabsData.productDetailsData?.scheduleLineDetails?.productDetailsChangeFlag === true;
        } else if (tabLabel === "Batch Allocation") {
          hasNotification = tabsData.batchAllocationData?.scheduleLineDetails?.newLotAllocationFlag === true;
        } else if (tabLabel === "Time and Qty. Details") {
          hasNotification = tabsData.timeQtyDetailsData?.scheduleLineDetails?.newProposalFlag === true;
        }

        // Base payload
        const Body = {
          schrockenSLID: tabsData.poDetailsData?.scheduleLineDetails?.schrockenSLID,
          viewedTab: tabLabel,
        };

        setLoading(true);

        axios
          .post(
            `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/updateUserActivity`,
            Body
          )
          .then((res) => {
            if (res.data.status) {
              //console.log("update user activity successfully");
              
              // If notification flag was true, refresh SL data and update quick summary
              // Without closing the row or unmounting the tab content
              if (hasNotification) {
                const schrockenSLID = tabsData.poDetailsData?.scheduleLineDetails?.schrockenSLID;
                if (schrockenSLID) {
                  // Refresh SL data to clear the badge
                  dispatch(fetchSLFromPODashboard(schrockenSLID))
                    .catch((error) => {
                      console.error("Failed to refresh SL details:", error);
                    });
                }
                
                // Update quick summary counts without closing the row
                if (handleQuickSummaryRefresh) {
                  handleQuickSummaryRefresh();
                }
              }
            }
          })
          .catch((err) => {
            console.error("API Error:", err);
          })
          .finally(() => {
            setLoading(false);
          });
      }
      // Update the ref to current tab value after API call
      previousTabRef.current = value;
    }

  }, [tabsData, value]);

  // useEffect(() => {
  //   if (data) {
  //     //setLoading(true);
  //     let requestData = {
  //       purchaseOrderNumber: data?.scheduleLineDetails?.scheduleAgreementNumber,
  //       schrockenPOLineID: data?.scheduleLineDetails?.schrockenSLID,
  //     };
  //     axios
  //       .post(
  //         `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchPOLineItemChatData`,
  //         requestData
  //       )
  //       // .then((res) => {
  //       //   if (res.data.status) {
  //       //     setChatData(res.data.chatData);
  //       //   }
  //       // })
  //       .then((res) => {
  //         if (res.data.status && res.data.chatData) {
  //           //setLoading(false);

  //           //setError("");
  //           setChatData(res.data.chatData);
  //           // Transform API data into the format used in `messages`
  //           const formattedMessages = res.data.chatData.map((chat) => ({
  //             sender: chat.chatSenderName,
  //             time: moment(chat.chatTimestamp).format("DD-MMM-YYYY HH:mm"),
  //             text: chat.chatData,
  //             // type:
  //             //   chat.chatSenderEmail === tokenData.email_address
  //             //     ? "sent"
  //             //     : "received",
  //             file: chat.chatFileName || null,
  //             // fileURL: chat.chatFileHash ? `${appUrl}/files/${chat.chatFileHash}` : null,
  //             schrockenChatID: chat.schrockenChatID || null,
  //             chatFileHash: chat.chatFileHash || null,
  //           }));

  //           // Set the messages state with the fetched data
  //           // setMessages(formattedMessages);
  //           setTimeout(() => {
  //             // scrollChatToBottom();
  //           }, 100);
  //         }
  //       })
  //       .catch((err) => {
  //         //setLoading(false);
  //         console.log(err);
  //         //setError("Something went wrong. Please try again.");
  //       });
  //   }
  // }, [data]);
  // console.log("chatData", chatData);

  // if (error) {
  //   return (
  //     <div
  //       style={{
  //         display: "flex",
  //         justifyContent: "center", // Horizontally center the CircularProgress
  //         alignItems: "center", // Vertically center the CircularProgress
  //         height: "50px", // Optional: Set a height to vertically center the loader
  //         border: "2px solid #FF0000",
  //         backgroundColor: "#FFF0F0",
  //         width: "100%",
  //       }}
  //     >
  //       <Typography style={{ textAlign: "center" }}>
  //         Something went wrong. Please try again.
  //       </Typography>
  //     </div>
  //   );
  // }
  // if (loading) {
  //   return (
  //     <div style={{ textAlign: "center" }}>
  //       <CircularProgress color="primary" thickness={7} />
  //     </div>
  //   );
  // }
  // if (apiData?.length === 0) {
  //   return (
  //     <div
  //       style={{
  //         display: "flex",
  //         justifyContent: "center", // Horizontally center the CircularProgress
  //         alignItems: "center", // Vertically center the CircularProgress
  //         height: "50px", // Optional: Set a height to vertically center the loader
  //         border: "2px solid #000",
  //         // backgroundColor: "#FFF0F0",
  //         width: "100%",
  //       }}
  //     >
  //       <Typography style={{ textAlign: "center" }}>
  //         No Records Found
  //       </Typography>
  //     </div>
  //   );
  // }

  return (
    <div className={classes.root}>
      <AppBar position="static" elevation={0}>
        <Tabs
          value={value}
          onChange={handleChange}
          classes={{
            root: classes.tabs,
            indicator: classes.indicator, // Style the indicator
          }}
        >
          <Tab
            label="PO Details"
            {...a11yProps(0)}
            classes={{ root: `${classes.tab} ${classes.poDetails}` }}
          />
          {/* <Tab
            label="Product Details"
            {...a11yProps(1)}
            classes={{ root: `${classes.tab} ${classes.productDetails}` }}
          /> */}

          <Tab
            label={
              <span
                style={{ display: "flex", alignItems: "center", gap: "5px" }}
              >
                Product Details
                {tabsData.productDetailsData?.scheduleLineDetails?.productDetailsChangeFlag ===
                  true && (
                  <span
                    style={{
                      backgroundColor: "#007AFF",
                      color: "white",
                      borderRadius: "50%",
                      width: "18px",
                      height: "18px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontSize: "12px",
                      fontWeight: "bold",
                    }}
                  >
                    1
                  </span>
                )}
              </span>
            }
            {...a11yProps(1)}
            classes={{ root: `${classes.tab} ${classes.productDetails}` }}
          />

          {/* <Tab
            label="Lot Allocation"
            {...a11yProps(2)}
            classes={{ root: `${classes.tab} ${classes.lotAllocation}` }}
            disabled={![25, 29, 30, 31].includes(scheduleLineStatusID)}
          /> */}

          <Tab
            label={
              <span
                style={{ display: "flex", alignItems: "center", gap: "5px" }}
              >
                Batch Allocation
                {tabsData.batchAllocationData?.scheduleLineDetails?.newLotAllocationFlag === true && (
                  <span
                    style={{
                      backgroundColor: "#007AFF",
                      color: "white",
                      borderRadius: "50%",
                      width: "18px",
                      height: "18px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontSize: "12px",
                      fontWeight: "bold",
                    }}
                  >
                    1
                  </span> 
                )}
              </span>
            }
            {...a11yProps(2)}
            classes={{ root: `${classes.tab} ${classes.lotAllocation}` }}
            disabled={batchAllocationNotApplicable || ((![25, 29, 30, 31,22,23].includes(scheduleLineStatusID)) && !([21].includes(scheduleLineStatusID) && localStorage.getItem('collabType') !== "CMO"))}
            
          />

          <Tab
            label="Delivery Details"
            {...a11yProps(3)}
            classes={{ root: `${classes.tab} ${classes.deliveryDetails}` }}
          />
          {/* <Tab
            label="Time and Qty. Details " 
            {...a11yProps(4)}
            classes={{ root: `${classes.tab} ${classes.timeQtyDetails}` }}
          /> */}
          <Tab
            label={
              <span
                style={{ display: "flex", alignItems: "center", gap: "5px" }}
              >
                Time and Qty. Details
                {tabsData.timeQtyDetailsData?.scheduleLineDetails?.newProposalFlag === true && (
                  <span
                    style={{
                      backgroundColor: "#007AFF",
                      color: "white",
                      borderRadius: "50%",
                      width: "18px",
                      height: "18px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontSize: "12px",
                      fontWeight: "bold",
                    }}
                  >
                    1
                  </span>
                )}
              </span>
            }
            {...a11yProps(4)}
            classes={{ root: `${classes.tab} ${classes.timeQtyDetails}` }}
          />
          <Tab
            label="Pricing"
            {...a11yProps(5)}
            classes={{ root: `${classes.tab} ${classes.pricing}` }}
          />

          <Tab
            label={
              <span
                style={{ display: "flex", alignItems: "center", gap: "5px" }}
              >
                Comments
                {tabsData.commentsData?.scheduleLineDetails?.unreadCommentsPresent === true && (
                  <span
                    style={{
                      backgroundColor: "#007AFF",
                      color: "white",
                      borderRadius: "50%",
                      width: "18px",
                      height: "18px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontSize: "12px",
                      fontWeight: "bold",
                    }}
                  >
                    1
                  </span>
                )}
              </span>
            }
            {...a11yProps(6)}
            classes={{ root: `${classes.tab} ${classes.comments}` }}
          />

          {/* <Tab
            label={`Response details`}
            {...a11yProps(5)}
            classes={{ root: classes.tab, selected: classes.selectedTab }}
          /> */}
        </Tabs>
      </AppBar>
      {/* Tab 0: PO Details - Basic schedule line information */}
      <TabPanel value={value} index={0}>
        <PODetailsTable 
          data={tabsData.poDetailsData} 
          featuresAccess={featuresAccess} 
        />
      </TabPanel>
      
      {/* Tab 1: Product Details - Product-specific information */}
      <TabPanel value={value} index={1}>
        <ProductDetailsTable
          data={tabsData.productDetailsData}
          handleRefresh={handleRefreshWithSLData}
          featuresAccess={featuresAccess}
          showPencilIcon={showPencilIcon}
        />
      </TabPanel>
      <TabPanel value={value} index={2}>
        <LotAllocationTable 
          data={tabsData.batchAllocationData} 
          featuresAccess={featuresAccess}  
          showPencilIcon={showPencilIcon} 
        />
      </TabPanel>
      
      {/* Tab 3: Delivery Details - Delivery and logistics information */}
      <TabPanel value={value} index={3}>
        <DeliveryDetailsTable 
          data={tabsData.deliveryDetailsData} 
        />
      </TabPanel>
      
      {/* Tab 4: Time and Qty Details - Negotiation and quantity information */}
      <TabPanel value={value} index={4}>
        <PONegotiationTable
          data={tabsData.timeQtyDetailsData}
          handleRefresh={handleRefreshOnlySLData}
          featuresAccess={featuresAccess}
          showPencilIcon={showPencilIcon}
        />
      </TabPanel>
      
      {/* Tab 5: Pricing */}
      <TabPanel value={value} index={5}>
        <PricingTable data={tabsData.pricingData} />
      </TabPanel>

      {/* Tab 6: Comments - Chat and comments */}
      <TabPanel value={value} index={6}>
        <CommentsBox 
          value={value} 
          data={tabsData.commentsData} 
          initiallyExpanded={true} 
          featuresAccess={featuresAccess}
          handleRefresh={handleRefresh}
          handleQuickSummaryRefresh={handleQuickSummaryRefresh}
        />
      </TabPanel>
    </div>
  );
}
